import { leagueFetch } from '@leagueplatform/league-fetch';
import { CARE_PROVIDERS_PATH } from '../constants/care-discovery.constants';
import { CareProvidersData } from '../types/care-discovery.types';

export const getCareProviders = async (): Promise<CareProvidersData> => {
  const response = await leagueFetch(`${CARE_PROVIDERS_PATH}`);

  return response.json();
};
